import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import "bootstrap-icons/font/bootstrap-icons.css";
import { set } from "date-fns";

const QRCodeManager = () => {
  const [loading, setLoading] = useState(false);
  const [qrCodes, setQrCodes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const guestId = localStorage.getItem("userid"); // Assuming userId is stored in localStorage
  const [qrImage, setQrImage] = useState(null);
  const [qrname, setqrname] = useState('');
  const [upiId, setUpiId] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [currentQRCode, setCurrentQRCode] = useState({
    _id: "",
    userId: guestId,
  });
  console.log(currentQRCode)
  useEffect(() => {
    loadQRCodes();
  }, []);

  // Fetch QR Codes
  const loadQRCodes = async () => {
    setLoading(true);
    try {
      // const response = await axios.get("https://api.Cash365days.in/admin/getQRCodeList");
      const response = await axios.get(`${process.env.REACT_APP_API_URL}admin/getQRCodeList`);
      setQrCodes(response.data.qrCodes);
    } catch (error) {
      console.error("❌ Error fetching QR codes:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle File Upload
  const handleFileChange = (e) => {
    setQrImage(e.target.files[0]);
  };

  // Handle Add QR Code
  const handleAddQRCode = () => {
    setIsEditing(false);
    setCurrentQRCode({ id: "", userId: guestId });
    setShowModal(true);
  };

  // Handle QR Code Submission
  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("userId", guestId);
    formData.append("qrImageUrl", qrImage);
    formData.append("qrname", qrname);
    formData.append("upiId", upiId);

    try {
      const url = isEditing
        ? `${process.env.REACT_APP_API_URL}admin/updateQRCode/${currentQRCode._id}`
        : `${process.env.REACT_APP_API_URL}admin/addQRCodes`;

      const method = isEditing ? axios.put : axios.post;
      const response = await method(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data) {
        Swal.fire(
          "Success!",
          `QR Code ${isEditing ? "updated" : "added"} successfully.`,
          "success"
        );
        setQrImage(null)
        setShowModal(false);
        setqrname('')
        setUpiId('')
        loadQRCodes();
      }
    } catch (error) {
      console.error("Error adding/updating QR Code:", error);
      Swal.fire("Error!", "Failed to add/update QR Code.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle Delete QR Code
  const handleDeleteQRCode = async (qrCodeId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.delete(
            `https://api.Cash365days.in/admin/deleteQRCode/${qrCodeId}`
          );
          loadQRCodes();
          if (response.data) {
            Swal.fire("Deleted!", response.message, "success");
          }
        } catch (error) {
          console.error("Error deleting QR Code:", error);
          Swal.fire("Error!", "Failed to delete QR Code.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };
  const handleUpdateQRCodeStatus = async (qrCodeId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to update the status to "${newStatus}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL}updateQRCodeStatus/${qrCodeId}`,
            { status: newStatus }
          );

          if (response.data.success == 1) {
            Swal.fire("Updated!", response.data.message, "success");
            loadQRCodes(); // Reload QR codes to reflect changes
          }
          if (response.data.success == 0) {
            Swal.fire("Warning!", response.data.message, "warning");
            loadQRCodes(); // Reload QR codes to reflect changes
          }
        } catch (error) {
          console.error("Error updating QR Code status:", error);
          Swal.fire("Error!", "Failed to update QR Code status.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const downloadQR = (imagePath, qrCodeId) => {
    setIsDownloading(true); // Start loading

    const imageUrl = `https://api.Cash365days.in/${imagePath}`;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `QR_image_${imagePath}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error("Error downloading image:", error);
      })
      .finally(() => {
        setIsDownloading(false); // Stop loading
      });
  };


  return (
    <div className="profile-container">
      <div className="table-responsive tablemargin">
        <p className="text-center mt-2 requesthistory">QR Code Management</p>
        <Button
          variant="primary"
          onClick={handleAddQRCode}
          className="mb-3 addbankbutton"
        >
          Add QR Code
        </Button>

        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" role="status" />
            <p>Loading...</p>
          </div>
        ) : (
          <Table
            striped
            bordered
            hover
            className="tablehistory position-relative"
          >
            <thead>
              <tr className="tablehead text-center">
                <th>#</th>
                <th>QR Code </th>
                <th>UPI Id</th>
                <th>QR Code Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="tbodyhistroy text-center">
              {qrCodes.length > 0 ? (
                qrCodes.map((qrCode, index) => (
                  <tr className="text-center" key={qrCode._id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={`https://api.Cash365days.in/${qrCode.qrImageUrl}`}
                        alt="QR Code"
                        width="110"
                        height="120"
                      />
                    </td>
                    <td>
                      {qrCode.upiId || 'N/A'}
                    </td>
                    <td>
                      {qrCode.qrname || 'N/A'}
                    </td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={qrCode.status === "active"}
                          onChange={() => handleUpdateQRCodeStatus(qrCode._id, qrCode.status)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>

                    <td>
                    <Button
                        variant="success"
                        className="buttonAction mx-1"
                        onClick={() => downloadQR(qrCode.qrImageUrl, qrCode._id)}
                        disabled={isDownloading}
                      >
                        {isDownloading ? (
                          <i className="bi bi-arrow-clockwise spin"></i>
                        ) : (
                          <i className="bi bi-download"></i>
                        )}
                      </Button>
                      <Button
                        className="buttonAction"
                        variant="warning"
                        size="sm"
                        onClick={() => {
                          setIsEditing(true);
                          setCurrentQRCode(qrCode);
                          setqrname(qrCode.qrname)
                          setUpiId(qrCode.upiId)
                          setShowModal(true);
                        }}
                      >
                        <i className="bi bi-pencil"></i>
                      </Button>{" "}
                      <Button
                        className="buttonAction"
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteQRCode(qrCode._id)}
                        disabled={qrCode.status === "active"} // Disable if active
                      >
                        <i className="bi bi-trash"></i>
                      </Button>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center nodataavl">
                    No QR Codes available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      {/* QR Code Modal */}
      {/* QR Code Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Edit QR Code" : "Add QR Code"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>QR Code Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter QR Code Name"
                value={qrname}
                onChange={(e) => setqrname(e.target.value)}
              />

            </Form.Group>
            <Form.Group>
              <Form.Label>Upi Id</Form.Label>
              <Form.Control
                type="text"
                placeholder="Upi Id"
                value={upiId}
                onChange={(e) => setUpiId(e.target.value)}
              />
            </Form.Group>


            <Form.Group>
              <Form.Label>Upload QR Code Image</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
          </Form>
          <div className="d-flex justify-content-center mt-2">
            {qrImage ? (
              <img
                src={qrImage instanceof File
                  ? URL.createObjectURL(qrImage)
                  : `https://api.Cash365days.in/uploads/${qrImage}`}
                alt="QR Code"
                width="100"
                height="150"
              />
            ) : (
              <img
                src={qrImage instanceof File
                  ? URL.createObjectURL(qrImage)
                  : `https://api.Cash365days.in/${currentQRCode.qrImageUrl}`}
                alt="QR Code"
                width="100"
                height="150"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!qrImage || !qrname || !upiId}>
            {isEditing ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default QRCodeManager;
